import httpHelper from '../../../../utils/httpHelper';
import { appConfig } from '../../../../constants/appConfig';
import { get } from 'react-hook-form';

const service = {

  async getSimCardList(params) {
    const endPoint = `simCard/getSimCardList`;
    const result = await httpHelper.makeGetRequest(
      appConfig.baseUrl,
      endPoint,
      params,
    );
    return result;
  },

  async getSimCardByBarcodeNumber(params) {
    const endPoint = `simCard/findSimCardByBarcodeNumber?barcodeNumber=${params.barcodeNumber}`;
    const result = await httpHelper.makeGetRequest(
      appConfig.baseUrl,
      endPoint,
    );
    return result;
  },

  async saveSimCard(payload) {
    const endPoint = 'simCard/saveSimCard';
    const result = await httpHelper.makePostRequest(
      appConfig.baseUrl,
      endPoint,
      payload,
    );
    return result;
  },

  async deleteSimCard(params) {
    const endPoint = `simCard/delete?id=${params.id}`;
    const result = await httpHelper.makeDeleteRequest(
      appConfig.baseUrl,
      endPoint,
    );
    return result;
  },

  async updateSimCard(payload) {
    const endPoint = `simCard/updateSimCard?simcardId=${payload.simCardId}`;
    const result = await httpHelper.makePutRequest(
      appConfig.baseUrl,
      endPoint,
      payload.data
    );
    return result;
  },

  async getSimCardDeviceList(params) {
    const endPoint = `simCardDevice/getSimCardDeviceList`;
    const result = await httpHelper.makeGetRequest(
      appConfig.baseUrl,
      endPoint,
      params,
    );
    return result;
  },

  async getSimCardDeviceById(params) {
    const endPoint = `simCardDevice/getById?id=${params.id}`;
    const result = await httpHelper.makeGetRequest(
      appConfig.baseUrl,
      endPoint,
    );
    return result;
  },

  async saveSimCardDevice(payload) {
    const endPoint = 'simCardDevice/save';
    const result = await httpHelper.makePostRequest(
      appConfig.baseUrl,
      endPoint,
      payload,
    );
    return result;
  },

  async deleteSimCardDevice(params) {
    const endPoint = `simCardDevice/delete?id=${params.id}`;
    const result = await httpHelper.makeDeleteRequest(
      appConfig.baseUrl,
      endPoint,
    );
    return result;
  },

  async updateSimCardDevice(payload) {
    const endPoint = `simCardDevice/updateSimCardDevice?simcardDeviceId=${payload.simcardDeviceId}`;
    const result = await httpHelper.makePutRequest(
      appConfig.baseUrl,
      endPoint,
      payload.data
    );
    return result;
  },

  async getAllSimcard() {
    const endPoint = `simCard/getAll`;
    const result = await httpHelper.makeGetRequest(
      appConfig.baseUrl,
      endPoint,
    );
    return result;
  },

  async getAllDevice() {
    const endPoint = `device/getAllDevices`;
    const result = await httpHelper.makeGetRequest(
      appConfig.baseUrl,
      endPoint,
    );
    return result;
  },

  async getSimcardsWithSearch(params) {
    const endPoint = `simCard/findSimCardSearch`;
    const result = await httpHelper.makeGetRequest(
      appConfig.baseUrl,
      endPoint,
      params,
    );
    return result;
  },

  async getSimCardDeviceWithSearch(params) {
    const endPoint = `simCardDevice/findSimCardDeviceSearch`;
    const result = await httpHelper.makeGetRequest(
      appConfig.baseUrl,
      endPoint,
      params,
    );
    return result;
  },
  async getDevicesWithSearch(params) {
    const endPoint = `device/findDeviceSearch`;
    const result = await httpHelper.makeGetRequest(
      appConfig.baseUrl,
      endPoint,
      params,
    );
    return result;
  },

  async getProductWithSearch(params) {
    const endPoint = `product/findProductSearch`;
    const result = await httpHelper.makeGetRequest(
      appConfig.baseUrl,
      endPoint,
      params,
    );
    return result;
  },
};

export default service;
